/**
 * 获取用户
 */
export const getUserInfo = '/common/getUserInfo';
/**
 * 服务器列表信息
 */
export const getServerList = '/common/getServerList';
/**
 * 游戏角色信息
 */
export const getGameRoleList = '/common/getGameRoleList';
/**
 * 游戏大区信息
 */
export const getAreaList = '/common/getAreaList';
/**
 * 积分商城开关
 */
export const getSwitchInfo = '/common/get/switchInfo';